module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "your-campaign"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "mb-30"
  }, [_vm._v(_vm._s(_vm.$t("project.yourCampaign")))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('crowdfunding-form', {
    attrs: {
      "project": _vm.project,
      "submit": _vm.submit,
      "errors": _vm.errors,
      "alert": _vm.alert
    },
    on: {
      "update:project": function($event) {
        _vm.project = $event
      }
    }
  }), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "crowd-or-rais"
  }, [_c('span', {
    staticClass: "domore-blue-1"
  }, [_vm._v("CROWDFUNDING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-50 mb-50"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/star.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-349d7d4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Crowdfunding/New.vue
// module id = 796
// module chunks = 1